import { Trans } from "react-i18next";

import util from "utils/utils";

export default function GroupAddedToCalendar({ events, ownerGroup }) {
  return (
    <Trans
      i18nKey="notifications.groupAddedToCalendarEvent"
      values={{
        events: util.getCalendarEventNames(events),
        group: ownerGroup?.name || "Deleted",
      }}
    />
  );
}
